import { render, staticRenderFns } from "./PersonalRequestFields.vue?vue&type=template&id=70ecb506"
import script from "./PersonalRequestFields.vue?vue&type=script&lang=js"
export * from "./PersonalRequestFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports